export default __webpack_public_path__ + "static/media/slick.29518378.woff";